module.exports = __webpack_public_path__ + "c_static/img/3-1手机京东收藏夹.d9feae7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/3-1手机京东收藏夹.jpg
// module id = TEvV
// module chunks = 33